import { FC } from 'react';

import styles from './styles.module.scss';

export const NoResults: FC = () => {
  return (
    <div className={styles.noResults}>
      <div className={styles.noResultsIconWrapper}>{/*<SearchIcon className={styles.noResultsIcon} />*/}</div>
      <p className={styles.noResultsTitle}>No Results Found</p>
    </div>
  );
};
